<template>
  <div class="aboutus" id="aboutus">
    <!--  -->
    <div class="one-bg-box">
      <div class="obb-box">
        <div class="obb-tit">山东路通石油</div>
        <div class="obb-txt">创新突破稳定品质</div>
        <div class="obb-txt">落实管理提高效率</div>
        <div class="obb-bottom-box">
          <div class="obb-bottom-b-icon obi-l"></div>
          <div class="obb-bottom-b-middle">用户满意是我们永恒的追求</div>
          <div class="obb-bottom-b-icon obi-r"></div>
        </div>
      </div>
    </div>
    <!--  -->
    <div class="part-building-box">
      <div class="pbb-tit-en">News Center</div>
      <div class="pbb-tit">
        <div class="pbbt-line"></div>
        <div class="pbbt-tit">新闻中心</div>
      </div>
      <div class="pbb-content">
        <div class="p-i-tit">油品类产品</div>
        <div class="pbbc-item">
          <div class="p-i-content">
            <img src="../static/productsone.png" alt="" class="pic-left" />
            <div class="pic-right">
              <div class="picr-tit">
                的卡拉李开复库萨克解放军啊离开教师节快乐公交卡司空见惯了就开了会计法设计开发解开了
              </div>
              <div class="picr-txt">
                卡箍金克拉赶紧看看撒健康管理卡箍就爱看高科卡箍金克拉赶紧看看撒健康管理卡箍就爱看高科技的健康老大哥健康的随机开关连脚裤看见噶改扩建改扩建2423立刻就发借记卡发卡卡技的健康老大哥健康的随机开关连脚裤看见噶改扩建改扩建2423立刻就发借记卡发卡卡
              </div>
            </div>
          </div>
        </div>
        <div class="pbbc-item">
          <div class="p-i-content">
            <img src="../static/productsone.png" alt="" class="pic-left" />
            <div class="pic-right">
              <div class="picr-tit">
                agklgklalkgjkljKJLsagajk就卡手机卡尽快立法金克拉金克拉
              </div>
              <div class="picr-txt">
                卡箍金克拉赶紧看看撒健康管理卡箍就爱看高科卡箍金克拉赶紧看看撒健康管理卡箍就爱看高科技的健康老大哥健康的随机开关连脚裤看见噶改扩建改扩建2423立刻就发借记卡发卡卡技的健康老大哥健康的随机开关连脚裤看见噶改扩建改扩建2423立刻就发借记卡发卡卡
              </div>
            </div>
          </div>
        </div>
        <div class="pbbc-item">
          <div class="p-i-content">
            <img src="../static/productsone.png" alt="" class="pic-left" />
            <div class="pic-right">
              <div class="picr-tit">
                agklgklalkgjkljKJLsagajk就卡手机卡尽快立法金克拉金克拉#
              </div>
              <div class="picr-txt">
                卡箍金克拉赶紧看看撒健康管理卡箍就爱看高科卡箍金克拉赶紧看看撒健康管理卡箍就爱看高科技的健康老大哥健康的随机开关连脚裤看见噶改扩建改扩建2423立刻就发借记卡发卡卡技的健康老大哥健康的随机开关连脚裤看见噶改扩建改扩建2423立刻就发借记卡发卡卡
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <page-bottom></page-bottom>
  </div>
</template>
<script>
import PageBottom from "../components/PageBottom.vue";
export default {
  components: {
    PageBottom,
  },
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.flex {
  display: flex;
}
.aboutus {
  .one-bg-box {
    height: 400px;
    background-image: url("../static/newscenterbg.jpg");
    background-size: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .obb-box {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .obb-tit {
        margin-top: 20px;
        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #e40316;
        opacity: 1;
      }
      .obb-txt {
        margin-top: 10px;
        font-size: 30px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #ffffff;
        opacity: 1;
      }
      .obb-bottom-box {
        display: flex;
        .obb-bottom-b-middle {
          padding: 0 5px;
          margin: 0 5px;
          display: flex;
          align-items: center;
          height: 30px;
          background-color: #ffffff;
          font-size: 16px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #333333;
        }
        .obb-bottom-b-icon {
          width: 60px;
          height: 30px;
          background-size: 100% 100%;
        }
        .obi-l {
          background-image: url("../static/homeiconleft.png");
        }
        .obi-r {
          background-image: url("../static/homeiconright.png");
        }
      }
    }
  }

  .part-building-box {
    padding: 60px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    .pbb-tit-en {
      font-size: 25px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #2e86a9;
      opacity: 1;
    }
    .pbb-tit {
      width: 600px;
      .pbbt-line {
        margin-top: 50px;
        width: 100%;
        border-bottom: 1px solid #000000;
      }
      .pbbt-tit {
        height: 40px;
        text-align: center;
        top: -20px;
        left: 200px;
        position: relative;
        width: 200px;
        background-color: #fff;
        font-size: 25px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #2e86a9;
        opacity: 1;
      }
    }
    .pbb-content {
      padding: 0 350px;
      .p-i-tit {
        margin-top: 40px;
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #333333;
        opacity: 1;
      }
      .pbbc-item {
        .p-i-content {
          margin-top: 20px;
          display: flex;
          .pic-left {
            height: 135px;
            width: 135px;
            margin-right: 100px;
          }
          .pic-right {
            display: flex;
            flex-direction: column;
            justify-content: center;
            .picr-tit {
              font-size: 16px;
              font-family: Source Han Sans CN;
              font-weight: 500;
              color: #666666;
              opacity: 1;
            }
            .picr-txt {
              margin-top: 20px;
              font-size: 12px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #999999;
              opacity: 1;
            }
          }
        }
      }
    }
  }
}
</style>

